import { useQuery } from '@tanstack/react-query'
import { api } from '../client'
import type { LinhaDaSerie } from '../../types/indicadores'

/**
 * A série histórica dos seis indicadores, da competência mais recente para a mais antiga.
 *
 * Consulta única: a série é curta por natureza — uma linha por competência do contrato — e as
 * linhas congeladas nem sequer são recalculadas no servidor. Pedir mês a mês faria o navegador
 * disparar 36 requisições para desenhar uma tabela.
 *
 * @returns a consulta da série
 */
export function useSerieDeIndicadores() {
  return useQuery({
    queryKey: ['indicadores', 'serie'],
    queryFn: async () => (await api.get<LinhaDaSerie[]>('/indicadores')).data,
  })
}
